import { useEffect, useMemo, useRef, useState } from "react";
import dropDownImage from "../../../assets/images/dropdown.svg";
import "../styles/toolbarSelect.css";

const ToolbarSelect = ({
  value,
  onChange,
  options = [],
  disabled = false,
  className = "",
  menuClassName = "",
  buttonClassName = "",
}) => {
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const normalizedValue = String(value ?? "");
  const normalizedOptions = useMemo(
    () =>
      (options || []).map((option) => ({
        value: String(option?.value ?? ""),
        label: String(option?.label ?? ""),
      })),
    [options]
  );

  const selectedOption = useMemo(
    () => normalizedOptions.find((option) => option.value === normalizedValue) || normalizedOptions[0] || null,
    [normalizedOptions, normalizedValue]
  );

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, []);

  useEffect(() => {
    if (disabled) {
      setIsOpen(false);
    }
  }, [disabled]);

  const handleSelect = (nextValue) => {
    setIsOpen(false);
    if (nextValue !== normalizedValue) {
      onChange?.(nextValue);
    }
  };

  return (
    <div
      ref={containerRef}
      className={`toolbar-select ${disabled ? "is-disabled" : ""} ${className}`.trim()}
    >
      <button
        type="button"
        className={`toolbar-select-trigger ${buttonClassName}`.trim()}
        onClick={() => !disabled && setIsOpen((open) => !open)}
        disabled={disabled}
      >
        <span className="toolbar-select-label" title={selectedOption?.label || ""}>
          {selectedOption?.label || ""}
        </span>
        <img className="toolbar-select-caret" src={dropDownImage} alt="" />
      </button>

      {isOpen ? (
        <div className={`toolbar-select-menu ${menuClassName}`.trim()}>
          {normalizedOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`toolbar-select-option ${option.value === normalizedValue ? "is-selected" : ""}`}
              onClick={() => handleSelect(option.value)}
              title={option.label}
            >
              {option.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ToolbarSelect;
